const BlockAnnouncementDefault = {
    object_id : null,
    name : 'Announcement',
    x : 0,
    y : 0,
    width : 5,
    height : 3,
    type : { name : 'announcement'},
    data : { message : ""},
    children : [
        {text: "", index : null, object_id : null, parent_block_id : null}
    ],
}

const BlockAnnouncementServerDefault = {
    type : 'announcement',
    message : ""
}

export {BlockAnnouncementDefault, BlockAnnouncementServerDefault} 